import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Due from '../../../../assets/img/due-date.png';
import Percentage from '../../../../assets/img/discount.png';
import Income from '../../../../assets/img/salary.png';
import Book from '../../../../assets/img/book.png';
import ReminderModal from './_reminderModal';
import jwt_decode from "jwt-decode";
import { serverUrl } from '../../../../serverUrl';
import { toast } from 'react-toastify';
import { fetchLandlordIds } from '../../../../serverUrl.js';


export default function DashboardMetrics({ defaulters, monthIncome, textColorClass, landlordCurrentOccupancy, textColorClassOccupancy, dataMetrics, }) {
  const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
  const getLandlordId = async () => {
      try {
          const landlordId = await fetchLandlordIds();
          return landlordId;
      } catch (error) {
          console.error('Error fetching Landlord ID:', error);
          return null;
      }
  };
  const landlordId = getLandlordId();
  const handleReminderModalOpen = () => {
    setIsReminderModalOpen(true);
  };

  const handleSendReminders = (reminderData) => {
    // reminderData: { customSubject, customMessage, addTemplate, reminderValue }
    const { customSubject, customMessage, addTemplate, reminderValue } = reminderData || {};
    try {
      const accessToken = localStorage.getItem("authTokens");
      // get the access token
      const parsedTokens = JSON.parse(accessToken);
      const access = parsedTokens.access;
      // headers access token
      const config = {
        headers: { Authorization: `Bearer ${access}` },
      };
      // decoding the token so that i can get the user id
      const decodedToken = jwt_decode(access);
      const userId = decodedToken.user_id;

      // get the landlord details that are linked to the user
      serverUrl
        .get(`/landlord/landlord/?user_id=${userId}`, config)
        .then((res) => {
          // get the landlord Id
          const landlordIds = res.data.results.map((landlord) => landlord.id);

          const data = {
            message: customMessage,
            subject: customSubject,
          };
          if (addTemplate) {
            const dataTemplate = {
              title: customSubject,
              text: customMessage,
              created_by_message_template: userId,
              updated_by_message_template: userId
            }
            // post the template
            serverUrl.post(`/communication/message-templates/`, dataTemplate, config)
              .then((res) => {
                toast.success("Message template saved successfully!");
              })
              .catch((error) => {
                console.log(error)
              })
          }
          if (reminderValue === 'general') {
            serverUrl.post(`/landlord/send_payment_reminder/?landlord_id=${landlordIds}`, data, config)
              .then((res) => {
                toast.success("Reminder sent successfully to all your tenants!");
                setIsReminderModalOpen(false);
              })
              .catch((error) => {
                console.log(error)
              })
          }
          else if (reminderValue) {
            serverUrl.post(`/landlord/send_payment_reminder/?apartment_id=${reminderValue}`, data, config)
              .then((res) => {
                toast.success("Reminder sent successfully to all the tenants in the selected property!");
                setIsReminderModalOpen(false);
              })
              .catch((error) => {
                console.log(error)
              })
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) { }
  };

  const [messageTemplates] = useState([]);

  const cards = [
    {
      title: "Rent Due",
      value: dataMetrics ? dataMetrics.rent_due?.toLocaleString() : 0,
      icon: Due,
      bgColor: "#c0dedc",
      shadowColor: "#c0dedc",
      textColor: "text-gray-800",
      buttons: null
    },
    {
      title: "Defaulters",
      value: defaulters ? defaulters.defaulters?.toLocaleString() : 0,
      icon: Book,
      bgColor: "#e6def1",
      shadowColor: "#e6def1",
      textColor: "text-gray-800",
      buttons: defaulters?.defaulters > 0 && (
        <div className="mt-2">
          <button
            className="bg-red-600 text-white text-sm p-2 rounded me-4"
            onClick={handleReminderModalOpen}
          >
            Send Reminders
          </button>
          <Link to='/defaulters-list' className="no-underline ml-2">
            <button className="bg-purple-700 text-white text-sm p-2 rounded">
              View
            </button>
          </Link>
        </div>
      )
    },
    {
      title: "Income",
      value: dataMetrics ? dataMetrics.rent_paid?.toLocaleString() : 0,
      icon: Income,
      bgColor: "#f1eee8",
      shadowColor: "#f1eee8",
      textColor: "text-gray-800",
      buttons: null
    },
    {
      title: "Occupancy",
      value: `${dataMetrics ? dataMetrics.occupancy_percentage : 0}%`,
      icon: Percentage,
      bgColor: "#f0dfdf",
      shadowColor: "#f0dfdf",
      textColor: "text-gray-800",
      buttons: null
    }
  ];

  return (
    <div className="w-full">
      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 px-2">
        {cards.map((card, index) => (
          <div
            key={index}
            style={{ minHeight: '50px', backgroundColor: card.bgColor, boxShadow: `${card.shadowColor}  10px 11px 25px 1px` }}
            className={`rounded-3xl ${card.textColor} p-4  transition-all`}
          >
            <div className="flex items-start">
              <img
                src={card.icon}
                alt={card.title}
                className="p-3 bg-white rounded-full w-20 h-20 mr-3"
              />
              <div className="flex-1">
                <h3 className="text-sm font-medium">{card.title}</h3>
                <p className="text-3xl font-bold mt-1">{card.value}</p>
                {card.buttons}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Reminder Modal */}
      <ReminderModal
        isOpen={isReminderModalOpen}
        onClose={() => setIsReminderModalOpen(false)}
        onSend={handleSendReminders}
        reminderType='landlord'
        landlord={landlordId}

      />
    </div>
  );
};